<template>
  <div class="driver-rating-container">
    <list-block>
      <list-filter
        :form="form"
        @search="handleSearch"
        @reset="handleReset"
      />
    </list-block>
    <list-block>
      <list-table
        :list="list"
        :form="form"
        :system-options="systemOptions"
        :loading="loading"
        @refresh="fetchData"
      />
      <pagination
        ref="levelRightsPagination"
        :total="total"
        :current-page="page"
        :page-size="size"
        @search="fetchData"
      />
    </list-block>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination/index.vue';
import ListBlock from '@/components/ListBlock/index.vue';
import { controlPage } from '@/api/userControl';
import { clearCloneForm } from 'ifs-utils';
import { getPermissionSystemPage } from '@/api/unifyUser';
import ListFilter from './components/ListFilter.vue';
import ListTable from './components/ListTable.vue';

const initSearchForm = () => ({
  unifyNameInStr: '',
  mobileInStr: '',
  companyIds: [],
  controlTypes: '',
  controlStatuses: '',
});

export default {
  name: 'LevelRights',
  components: {
    Pagination,
    ListBlock,
    ListFilter,
    ListTable,
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 20,
      loading: false,
      form: initSearchForm(),
      list: [],
      systemOptions: [],
    };
  },
  created() {
    this.fetchSystemOptionsData();
    this.fetchData();
  },
  methods: {
    async fetchData(page, size) {
      this.loading = true;
      try {
        this.page = page || this.page;
        this.size = size || this.size;
        const data = clearCloneForm(this.form);
        const params = {
          page: this.page,
          size: this.size,
          sort: 'update_time__DESC',
        };
        const resp = await controlPage({
          ...data,
          needConfigDetail: true,
        }, params);
        this.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.$refs.levelRightsPagination.resetPage();
      this.fetchData();
    },
    handleReset() {
      this.form = initSearchForm();
      this.page = 1;
      this.$refs.levelRightsPagination.resetPage();
      this.fetchData();
    },
    async fetchSystemOptionsData() {
      try {
        const resp = await getPermissionSystemPage({}, { size: 9999 });
        this.systemOptions = resp.records;
      } catch (err) {
        this.driverLevelOptions = [];
      }
    },
  },
};
</script>
